export default __webpack_public_path__ + "static/media/DUSTY_2.221ad40e.gif";